
<h5 class="widget-header" *ngIf="(hayVideos || (isAdmin||isContribuidor))"><i class="fas fa-video"></i> Video Tutoriales</h5>
<span *ngIf="(isAdmin||isContribuidor) && (respuestaId)">Asociar video <a (click)="nuevoVideo()" data-toggle="tooltip" title="Nuevo Video"  class="btn btn-primary add"><i class="fas fa-plus"></i></a></span>
<div *ngFor="let video of videos">
  <h4>{{video.nombre}}
    <a (click)="editarVideo(video.id)" data-toggle="tooltip" title="Editar Video" *ngIf="isAdmin||isContribuidor" class="btn_ico"><i class="fa fa-1x fa-edit"></i></a>
    <a (click)="borrarVideo(video.id, video.nombre)" data-toggle="tooltip" title="Eliminar Video" *ngIf="isAdmin" class="btn_ico"><i class="fa fa-1x fa-trash-alt"></i></a>
  </h4>
  <div class="video-responsive" >
    <iframe
      [src]="video.descripcion | domseguro"
      [title]="video.nombre"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    >
    </iframe>
  </div>
  <br>
</div>
<app-loading *ngIf="loading" class="m-5"></app-loading>


